import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_SPRING_ENDPOINT } from "../app/api/config";
import { format } from "date-fns";
import { HTTP_METHODS } from "../app/Utils/CONST";
import { getActiveHotelId } from "../app/Utils/Utils";

export const springApi = createApi({
  reducerPath: "springApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_SPRING_ENDPOINT,
    prepareHeaders: (headers) => {
      let token = localStorage.getItem("token");
      if (token.includes("||master"))
        token = token.substring(0, token.length - 8);
      console.log("abhishek token: ", token);
      if (token) {
        headers.set("Authorization", `${token}`);
      }
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  tagTypes: ["OtaRoomAssignment"],
  endpoints: (builder) => ({
    getQuickBookPricePayload: builder.mutation({
      query: ({
        checkInDate,
        checkOutDate,
        selectedCheckInSlot,
        selectedCheckOutSlot,
        hotelId,
        newRate,
        rateType,
        bookingId,
      }) => ({
        url: "core/api/v1/reservation/getQuickEditPricePayload",
        method: HTTP_METHODS.POST,
        body: {
          checkin:
            format(new Date(checkInDate), `dd-MM-yyyy`) +
            ` ${selectedCheckInSlot}:00:00`,
          checkout:
            format(new Date(checkOutDate), `dd-MM-yyyy`) +
            ` ${selectedCheckOutSlot}:00:00`,
          hotelId,
          newRate,
          newRateType: rateType,
          bookingId,
        },
      }),
    }),
    getOtaRoomAssignmentConfigs: builder.query({
      query: () => ({
        url: `core/api/v1/ota-room-assignment/get-config?hotelId=${getActiveHotelId()}`,
        method: HTTP_METHODS.GET,
      }),
      providesTags: ["OtaRoomAssignment"],
    }),
    deleteOtaRoomAssignmentConfig: builder.mutation({
      query: (id) => ({
        url: `core/api/v1/ota-room-assignment/delete-config`,
        method: HTTP_METHODS.DELETE,
        params: { id, hotelId: getActiveHotelId() },
      }),
      invalidatesTags: ["OtaRoomAssignment"],
    }),
  }),
});

export const {
  useGetQuickBookPricePayloadMutation,
  useGetOtaRoomAssignmentConfigsQuery,
  useDeleteOtaRoomAssignmentConfigMutation,
} = springApi;
